module.exports = __webpack_public_path__ + "img/gzpn.26302c62.png";